import { getLoggedInUserId } from 'public/users.js';
import { submitButtonEvent } from 'public/event-firing.js';
import { ipLookup, countryLookup } from 'public/coordinateLookup.js'
import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('potential-experts', 80, { msid: 'ea356ca1-879f-4703-8de8-ee8dd93a00c7' });

const birdsDuration = 500;
const url = wixLocation.url;
let lp = 'lets-talk';
let campaign = wixLocation.query.utm_campaign;
if (campaign) { campaign = campaign.split('_')[2]; }
let campaignId, experimentId, adgroup, acqCampaignName;
let language, userId, countryCode, clientId;

$w.onReady(async function () {

    $w('#customElement1').on('myEvent', ({ detail: { data } }) => {
        clientId = data
        console.log(clientId)

    });

    let searchParams = wixLocation.query
    console.log(searchParams, 'searchParams')

    if (searchParams['utm_campaign']) {
        campaignId = searchParams['utm_campaign']
        console.log(campaignId, 'here')

        let arrayOfTerms = campaignId.split('_')

        arrayOfTerms.forEach((term) => {
            if (term.includes('-')) {
                acqCampaignName = term;
            }
        })
    }

    if (searchParams['experiment_id']) {

        experimentId = searchParams['experiment_id']
        console.log(experimentId, 'experimentId')

        adgroup = searchParams['experiment_id'].substr(0, experimentId.indexOf('^'))
        console.log(adgroup, 'adgroup')

    }

    pageEvents();
    let ip = await ipLookup()
    let countryData = await countryLookup(ip.ip)
    language = await wixWindow.browserLocale.slice(0, 2)
    countryCode = countryData.country_code
    const success = await getLoggedInUserId();
    userId = success.slice(success.indexOf('"guid":"') + 8, success.indexOf('"guid":"') + 44);
});

// $w('#customElement1').collapse()
setTimeout(() => {
    $w('#customElement1').setAttribute('ready', true);
}, 2000)

async function pageEvents() {
    const inputs = ["Fullname", "Email", "Phone", "WebsiteUrl"];
    inputs.forEach((input) => {
        $w("#input" + input).onFocus(() => {
            if (input !== "WebsiteUrl" && wixWindow.formFactor === "Desktop") {
                $w('#warning' + input).hide();
            }
            // $w('#title' + input).expand();
            $w('#title' + input).show();
            $w('#input' + input).placeholder = ''
        })
        $w("#input" + input).onKeyPress(() => {
            if (input !== "WebsiteUrl" && wixWindow.formFactor === "Desktop") {
                $w('#warning' + input).hide();
            }
            // $w('#title' + input).expand();
            $w('#title' + input).show();
            $w('#input' + input).placeholder = ''
        })

        $w("#input" + input).onBlur(() => {
            if ($w("#input" + input).value === '') {
                // $w('#title' + input).collapse();
                $w('#title' + input).hide();
                $w('#input' + input).placeholder = getPlaceHolderText(input)
            }
            if (input !== "WebsiteUrl" && wixWindow.formFactor === "Desktop") {
                $w("#input" + input).valid ? $w('#warning' + input).hide() : $w('#warning' + input).show();
            }
        })

        $w("#input" + input).onChange(() => {
            if ($w("#input" + input).value === '') {
                // $w('#title' + input).collapse();
                $w('#title' + input).hide();
                $w('#input' + input).placeholder = getPlaceHolderText(input)
            }
            if (input !== "WebsiteUrl") {
                $w("#input" + input).valid ? $w('#warning' + input).hide() : $w('#warning' + input).show();
            }
        })
    })

    $w('#buttonSubmit1').onClick(async () => {
        console.log('clicked')
        $w('#buttonSubmit1').disable();
        if (formValidation()) {
            console.log('send form data')
            await sendFormData();

        } else {
            $w('#buttonSubmit1').enable();
        }
    })
}

function getPlaceHolderText(input) {
    let placeHolder;
    switch (input) {
    case 'Fullname':
        placeHolder = 'Full name'
        break;
    case 'Email':
        placeHolder = 'Business email'
        break;
    case 'Phone':
        placeHolder = 'Phone number'
        break;
    case 'WebsiteUrl':
        placeHolder = 'Website URL'
        break;
    }
    return placeHolder
}

async function sendFormData() {
    console.log(clientId)
    const formData = {
        inputLp: lp,
        uuid: userId,
        language: language,
        countryCode: countryCode,
        clientId: clientId,
        inputCampaign: campaign,
        campaignId,
        experimentId,
        adgroup,
        inputEmail: $w('#inputEmail').value,
        inputFullName: $w('#inputFullname').value,
        inputPhone: $w('#inputPhone').value,
        websiteUrl: $w('#inputWebsiteUrl').value,
        source: wixLocation.url,
        acq_campaign_name: acqCampaignName
    }
    let item = await wixData.insert("formDB", formData);
    const biEventObject = {
        evid: 501,
        topic: "partners LP",
        button_name: "Let's Talk",
        additional_info: "Let's talk form LP",
        formDetailsJson: JSON.stringify(formData),
        formIsValid: true,
        leadId: item._id,
        full_url: wixLocation.url
    };
    await submitButtonEvent(item._id, url, biEventObject.additional_info, biEventObject.button_name, biEventObject.formDetailsJson, biEventObject.topic)
    // biLogger.log(BIEventObject);
    console.log('sent')
    wixLocation.to('https://www.wix.com/partners/lets-talk-thank-you')
}

function formValidation() {
    let valid = true;
    $w("#checkbox1").updateValidityIndication();
    if (!$w('#checkbox1').checked) {
        valid = false;
    }
    if (!$w('#inputFullname').valid) {
        $w('#warningFullname').show();
        valid = false
    }
    if (!$w('#inputEmail').valid) {
        $w('#warningEmail').show();
        valid = false
    }

    if (!$w('#inputPhone').valid) {
        $w('#warningPhone').show();
        valid = false
    }
    return valid;
}